<template>
  <ol class="list-decimal">
    <li>
      {{ i18n(translations.openBlankCsv) }}
      <ul class="body-2 mb-4 ml-4 mt-2">
        <li>{{ i18n(translations.sku) }}</li>
        <li>{{ i18n(translations.stock) }}</li>
        <li>{{ i18n(translations.price) }}</li>
      </ul>
    </li>
    <li>
      {{ i18n(translations.fillOutListingDetails) }}
    </li>
    <li>
      {{ i18n(translations.uploadFinalCsv) }}
    </li>
  </ol>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from '../Form.translations'

const i18n = useI18n()
</script>
